/**
 * 小売開栓結果登録API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 受付情報
 */
export interface Sgkb121aResAceptInfoDto {
    /** 
     * 受付番号：半角数字
     */
    aceptNo?: string;
    /** 
     * 受付履歴番号：半角数字
     */
    aceptRrkno?: string;
    /** 
     * 内部お客さま番号：半角数字
     */
    visitNo?: string;
    /** 
     * 請求お客さま番号：半角数字
     */
    recptFixNo?: string;
    /** 
     * 同時受付番号：半角数字
     */
    simltnAceptNo?: string;
    /** 
     * 受付種別コード：半角英数混在
     */
    aceptClsfy?: string;
    /** 
     * 受付種別コード名称：全角文字
     */
    aceptClsfyAname?: string;
    /** 
     * 受付日付：日付YYYYMMDD
     */
    aceptDate?: string;
    /** 
     * 受付時刻：時間HHMM
     */
    aceptHms?: string;
    /** 
     * 受付ステータス：半角英数混在
     */
    aceptSts?: string;
    /** 
     * 受付ステータス名称：全角文字
     */
    aceptStsAname?: string;
}